import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { AlertCircle } from 'lucide-react';
import { Button } from '@/components/atoms/button';
import { ContactBillToFormPanel } from '@/components/organisms/contacts/ContactBillToFormPanel';
import { useBillTo } from '@/hooks/contacts/useBillTo';
import { useContact } from '@/hooks/contacts/useContact';

export const Route = createFileRoute('/_dashboard/dashboard/contacts/$contactId/bill-to/new')({
  component: NewBillToPage,
});

function NewBillToPage() {
  const { contactId } = Route.useParams();
  const navigate = useNavigate();
  const contactQuery = useContact(contactId);
  const billToQuery = useBillTo(contactId);

  function navigateToContact() {
    void navigate({
      to: '/dashboard/contacts/$contactId',
      params: { contactId },
    });
  }

  if (contactQuery.isError && contactQuery.error?.status === 404) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-4 text-center">
        <AlertCircle className="h-10 w-10 text-muted-foreground" />
        <div>
          <p className="font-semibold">Contact not found</p>
          <p className="text-sm text-muted-foreground">The contact may have been deleted.</p>
        </div>
        <Button onClick={() => navigate({ to: '/dashboard/contacts' })}>Back to Contacts</Button>
      </div>
    );
  }

  return (
    <ContactBillToFormPanel
      mode="create"
      contactId={contactId}
      currentContact={contactQuery.data}
      entriesCount={billToQuery.data?.length ?? 0}
      isLoading={contactQuery.isLoading || billToQuery.isLoading}
      onCancel={navigateToContact}
      onSaved={navigateToContact}
    />
  );
}
